const initialState = {
  data: null,
  loading: null,
  error: null,
  filters: {
    offset: 0,
    limit: 6,
    startData: null,
    endData: null,
    description: null,
  },
};

export default initialState;
